<template>
  <div class="w-full">
    <div
      class="flex flex-row px-[12px] md:px-[16px] lg:px-[20px] gap-[16px] md:gap-[20px] lg:gap-[24px] h-[56px] md:h-[64px] lg:h-[68px] items-center"
    >
      <img
        src="/assets/icons/my-giving/ModeOfGivingGift.svg"
        alt="giving"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
      <a
        @click="gotoModeOfGiving()"
        class="flex-1 text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] font-[500] text-[#21201E]"
      >
        <p>Types of Funds</p>
      </a>
      <img
        @click="gotoModeOfGiving()"
        src="/assets/icons/my-giving/GivingChevronRight.svg"
        alt="giving"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
    </div>
    <div
      class="flex flex-row px-[12px] md:px-[16px] lg:px-[20px] gap-[16px] md:gap-[20px] lg:gap-[24px] h-[56px] md:h-[64px] lg:h-[68px] items-center"
    >
      <img
        src="/assets/icons/my-giving/GivingFAQs.svg"
        alt="givingFAQs"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
      <a
        @click="gotoFAQ()"
        class="flex-1 text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] font-[500] text-[#21201E]"
      >
        <p>FAQs</p>
      </a>
      <img
        @click="gotoFAQ()"
        src="/assets/icons/my-giving/GivingChevronRight.svg"
        alt="giving"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
    </div>
    <div
      class="flex flex-row px-[12px] md:px-[16px] lg:px-[20px] gap-[16px] md:gap-[20px] lg:gap-[24px] h-[56px] md:h-[64px] lg:h-[68px] items-center"
    >
      <img
        src="/assets/icons/my-giving/GivingContactUs.svg"
        alt="givingFAQs"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
      <a
        @click="gotoContactUs()"
        class="flex-1 text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] font-[500] text-[#21201E]"
      >
        <p
          class="flex-1 text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] font-[500] text-[#21201E]"
        >
          Contact Us
        </p>
      </a>
      <img
        @click="gotoContactUs()"
        src="/assets/icons/my-giving/GivingChevronRight.svg"
        alt="giving"
        class="size-[24px] md:size-[28px] lg:size-[32px]"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gotoModeOfGiving() {
      this.$router.push('/my-giving/giving-mode');
    },
    gotoFAQ() {
      this.$router.push('/my-giving/faq');
    },
    gotoContactUs() {
      this.$router.push('/my-giving/contact-us');
    },
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
